import React from 'react'
import Header from './Header'
import clsx from 'clsx'

type Props = {
  title: string | any
  children: React.ReactNode
  className?: string
  footer?: any
  headerClassName?: string
  toolbar?: any
  subTitle?: string
  isCustomFooter?: any
}

export const OrderCard: React.FC<Props> = ({
  className,
  children,
  footer,
  headerClassName,
  toolbar,
  isCustomFooter,
  ...props
}) => {
  return (
    <div className='card shadow-lg rounded-10 mb-7'>
      <Header className={headerClassName} {...props}>
        {toolbar && <>{toolbar}</>}
      </Header>
      <div className={clsx('card-body', className)}>{children}</div>
      {isCustomFooter ? (
        <>{isCustomFooter}</>
      ) : (
        <>{footer && <div className='card-footer'>{footer}</div>}</>
      )}
    </div>
  )
}

export default OrderCard
